module.exports = __webpack_public_path__ + "static/for_whom_housing_communities-a4719a32a83567c77a6b9da1ba634ff7.jpg";